import React from "react";
import { copyText } from "../../../utils/copy-text";
import { meetingProviderLabel } from "./meeting-provider-label";

/**
 * Per-booking Zoom / Google Meet link of an online consult, shown to the coach.
 * Renders nothing for in-person bookings; when the provider link could not be
 * generated the coach is told to send the guest a link themselves.
 */
const BookingMeetingLink = ({ url, provider, status }) => {
  const [copyResult, setCopyResult] = React.useState(null);

  React.useEffect(() => {
    if (!copyResult) return undefined;
    const t = setTimeout(() => setCopyResult(null), 2000);
    return () => clearTimeout(t);
  }, [copyResult]);

  const label = meetingProviderLabel(provider);

  if (!url) {
    if (status !== "failed" && status !== "unavailable") return null;
    // "unavailable" = the hosting coach has no usable provider connection.
    return (
      <span
        className="scheduling-meeting-link scheduling-meeting-link--missing"
        title={`No ${label} link was created for this booking - send the guest a link yourself.`}
      >
        {status === "unavailable"
          ? `${label} not connected`
          : `${label} link failed`}
      </span>
    );
  }

  const copy = async () =>
    setCopyResult((await copyText(url)) ? "copied" : "failed");

  return (
    <span className="scheduling-meeting-link">
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="scheduling-meeting-link-open"
        title={url}
      >
        Join {label}
      </a>
      <button
        type="button"
        className="scheduling-meeting-link-copy"
        onClick={copy}
      >
        {copyResult === "copied"
          ? "Copied"
          : copyResult === "failed"
            ? "Copy failed"
            : "Copy link"}
      </button>
    </span>
  );
};

export default BookingMeetingLink;
